// extracted by mini-css-extract-plugin
export default {"container":"TCLHPt","title":"kgDIDl","text":"VgsMHO","button":"J0iaM4"};